import React from 'react'

const S3_about = () => {
  return (
<section className='S3_about'>
    <div className='Follow'>
        <h3>Follow Us</h3>

    <ul>
        <li> <a href="https://www.facebook.com/"><i className="fa-brands fa-facebook-f"></i></a></li>
        <li> <a href="https://www.youtube.com/"><i className="fa-brands fa-youtube"></i></a></li>
        <li> <a href="https://www.linkedin.com/"><i className="fa-brands fa-linkedin"></i></a></li>
        <li> <a href="https://www.instagram.com/"><i className="fa-brands fa-instagram"></i></a></li>

    </ul>

    </div>   

</section>
  )
}

export default S3_about